import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

import { QueryFilters } from 'components';
import { FilterDefinition } from 'types';

import { ExportFundsRequests } from '../ExportFundsRequests';

type Props = {
  archived: boolean;
  queryResult: any;
  filtersDefinitions: FilterDefinition[];
};

export const FundsRequestsActions: React.FC<Props> = ({
  archived,
  queryResult,
  filtersDefinitions,
}) => {
  const exportEnabled = useMemo(
    () => !isEmpty(queryResult.data?.items),
    [queryResult],
  );

  return (
    <div className="tw-flex tw-items-center tw-justify-end">
      <div className="tw-flex-1">
        <QueryFilters filtersDefinitions={filtersDefinitions} />
      </div>
      {exportEnabled && <ExportFundsRequests archived={archived} />}
    </div>
  );
};
